// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventItem_wrapper_1U2Cs","firstLine":"EventItem_firstLine_2B0Rb","title":"EventItem_title_2LYlm","date":"EventItem_date_3diWh","author":"EventItem_author_1-pC0"};